import { gql } from "@apollo/client";

export default gql`
  mutation removeWorkerTags($workerId: ID!, $tags: [String!]!) {
    removeWorkerTags(workerId: $workerId, tags: $tags) {
      id
    }
  }
`;
